import React from 'react';
import { supabaseClient } from '../../config/supabase';
import AddressField from './AddressField';

// The staff app's address field: the shared AddressField with the signed-in staff client (M19 T7).
function AddressAutocomplete({ value, onChange, label, inputClassName, placeholder, module = 'dispatch', id, maxLength, client = supabaseClient }) {
    return <AddressField client={client} value={value} onChange={(text) => onChange(text)} label={label} inputClassName={inputClassName} placeholder={placeholder} module={module} id={id} maxLength={maxLength} />;
}

export default AddressAutocomplete;
